import React, { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "core/presentation/store/hooks";
import { userThunks } from "user/presentation/store/userSlice";
import DonutChart from "core/presentation/components/DoughnutChartComponent";
import ATitle from "core/presentation/components/Title";

const NoOfVehicles: React.FC = () => {
  const dispatch = useAppDispatch();

  const dashboardData = useAppSelector((state) => state.user.dashboardData);

  const extractData = (convertedVehicleData: any) => {
    const { Total, ...data } = convertedVehicleData;
    const labels = Object.keys(data);
    const rates = labels.map((key) => ((data[key] / Total) * 100).toFixed(2));

    return { labels, rates, total: Total };
  };

  // const dashboardData = {
  //   summary: {
  //     vehicleOwner: {
  //       Active: 10,
  //       Inactive: 10,
  //     },
  //     shipper: {
  //       Active: 1,
  //       Inactive: 0,
  //     },
  //     driver: {
  //       Active: 10,
  //       Inactive: 5,
  //     },
  //   },
  //   noOfVehicles: {
  //     convertedVehicleData: {
  //       InJob: 999,
  //       Available: 555,
  //       Total: 10000,
  //       Others: 222,
  //     },
  //   },
  // };

  const { labels, rates, total } = extractData(
    dashboardData.noOfVehicles.convertedVehicleData
  );

  const data = {
    labels,
    datasets: [
      {
        data: rates,
        backgroundColor: ["#FF4D4F", "#FFA940", "#1890FF", "#73D13D"],
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: "#ffffff",
        font: {
          size: 12,
          weight: 500,
        },
        formatter: (value: any, context: any) => {
          return value + "%";
        },
      },
    },
    rotation: -90,
    circumference: 180,
    cutout: "60%",
    maintainAspectRatio: true,
    responsive: true,
    layout: {
      padding: {
        top: 20,
        bottom: 20,
      },
    },
  };

  return (
    <div
      style={{
        padding: "40px",
        border: "1px solid #EAECF0",
        borderRadius: "8px",
        // height: "95%",
        background: "#fff",
        textAlign: "left",
      }}
    >
      <ATitle
        level={4}
        style={{ fontSize: 16, fontWeight: 600 }}
        content={"No of Vehicles"}
      />
      <ATitle
        level={2}
        style={{ fontSize: 32, fontWeight: 700, margin: "10px 0" }}
        content={total}
      />
      <DonutChart data={data} options={options} />
      <div
        style={{ display: "flex", justifyContent: "flex-start", marginTop: 20 }}
      >
        {labels.map((label, index) => (
          <div style={{ display: "flex", marginRight: 15 }} key={label}>
            <div
              style={{
                width: 10,
                height: 10,
                backgroundColor: data.datasets[0].backgroundColor[index],
                borderRadius: "50%",
                marginRight: 5,
              }}
            ></div>
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NoOfVehicles;
